var storefrontApp = angular.module('storefrontApp');

storefrontApp.directive('vcContentPlace', ['$compile', 'marketingService', function ($compile, marketingService) {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            marketingService.getDynamicContent(attrs.id).then(function (response) {
                element.html($compile(response.data)(scope));
            });
        },
        replace: true
    }
}]);

storefrontApp.directive('fallbackSrc', function () {
    return {
        link: function (scope, element, attrs) {
            element.on('error', errorHandler);

            scope.$on('$destroy', function() {
                element.off('error', errorHandler);
            });

            function errorHandler(event) {
                if (element.attr('src') !== attrs.fallbackSrc) {
                    element.attr('src', attrs.fallbackSrc);
                }
                else {
                    element.off(event);
                }
            };
        }
    }
});

storefrontApp.directive('valueMatches', ['$parse', function ($parse) {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ngModel) {
            var originalModel = $parse(attrs.valueMatches),
                secondModel = $parse(attrs.ngModel);

            // Watch for changes to this input
            scope.$watch(attrs.ngModel, function (newValue) {
                if (angular.isDefined(originalModel(scope))) {
                    ngModel.$setValidity(attrs.name, newValue === originalModel(scope));
                }
            });
            // Watch for changes to the value-matches model's value
            scope.$watch(attrs.valueMatches, function (newValue) {
                if (angular.isDefined(newValue)) {
                    ngModel.$setValidity(attrs.name, newValue === secondModel(scope));
                }
            });
            
        }
    };
}]);
